(()=>{
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile=window.matchMedia('(max-width: 820px), (hover: none), (pointer: coarse)');
  const entryObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting||!mobile.matches||reduced.matches)return;
      entry.target.dataset.srdEntrySeen='true';
      entry.target.classList.add('srd-mobile-intro');
      entry.target.addEventListener('animationend',()=>entry.target.classList.remove('srd-mobile-intro'),{once:true});
      entryObserver.unobserve(entry.target);
    });
  },{threshold:.7}):null;
  const ambientObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>entry.target.dataset.srdAmbient=String(entry.isIntersecting&&!reduced.matches));
  },{threshold:.5}):null;
  function init(root=document){
    root.querySelectorAll('.button,.srd-announcement-offer,.srd-offer-open,.srd-welcome-close,.srd-offer-dismiss,.srd-guide-choice,.srd-photo-dialog button').forEach(button=>{
      if(entryObserver&&mobile.matches&&!reduced.matches&&!button.dataset.srdEntrySeen&&button.matches('.srd-hero-actions .button'))entryObserver.observe(button);
      if(button.dataset.srdInkBound)return;
      button.dataset.srdInkBound='true';
      if(ambientObserver&&button.matches('.srd-hero-actions .button'))ambientObserver.observe(button);
      let releaseTimer;
      const release=immediate=>{
        clearTimeout(releaseTimer);
        if(immediate)button.classList.remove('srd-is-pressed');
        else releaseTimer=setTimeout(()=>button.classList.remove('srd-is-pressed'),180);
      };
      button.addEventListener('pointerdown',event=>{
        if(reduced.matches||button.disabled||event.button>0||button.getAttribute('aria-busy')==='true')return;
        clearTimeout(releaseTimer);
        button.classList.remove('srd-mobile-intro');
        button.classList.add('srd-is-pressed');
        if(!button.animate)return;
        button.querySelectorAll('.srd-button-ink').forEach(ink=>ink.remove());
        const rect=button.getBoundingClientRect();
        const diameter=Math.hypot(rect.width,rect.height)*2;
        const ink=document.createElement('span');
        ink.className='srd-button-ink';
        ink.setAttribute('aria-hidden','true');
        Object.assign(ink.style,{width:diameter+'px',height:diameter+'px',left:(event.clientX-rect.left-diameter/2)+'px',top:(event.clientY-rect.top-diameter/2)+'px'});
        button.append(ink);
        ink.animate([{transform:'scale(0)',opacity:.7},{transform:'scale(1)',opacity:0}],{duration:720,easing:'ease-out'}).finished.then(()=>ink.remove()).catch(()=>ink.remove());
      });
      button.addEventListener('pointerup',()=>release(false));
      button.addEventListener('pointercancel',()=>release(true));
      button.addEventListener('pointerleave',()=>release(true));
      button.addEventListener('blur',()=>release(true));
      button.addEventListener('keydown',event=>{if(!reduced.matches&&!button.disabled&&(event.key==='Enter'||event.key===' '))button.classList.add('srd-is-pressed')});
      button.addEventListener('keyup',()=>release(false));
    });
    root.querySelectorAll('[data-srd-product]').forEach(section=>{
      if(section.dataset.srdMotionBound)return;
      section.dataset.srdMotionBound='true';
      const pulse=()=>{
        if(reduced.matches)return;
        section.querySelectorAll('[data-srd-current-price],[data-srd-order-total],[data-srd-order-labels]').forEach(element=>{
          if(!element.animate)return;
          element.getAnimations().forEach(animation=>animation.cancel());
          element.animate([{opacity:.4,transform:'translateY(10px) scale(.94)'},{opacity:1,transform:'translateY(-2px) scale(1.06)',offset:.55},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:520,easing:'cubic-bezier(.2,.75,.25,1)'});
        });
        const summary=section.querySelector('[data-srd-order-summary]');
        if(summary?.animate){summary.getAnimations().forEach(animation=>animation.cancel());summary.animate([{boxShadow:'0 0 0 4px #26794e70',backgroundColor:'#d6efdf'},{boxShadow:'0 0 0 0 #26794e00',backgroundColor:'var(--srd-panel)'}],{duration:850,easing:'ease-out'})}
        const selected=section.querySelector('.srd-pack-choice[aria-pressed="true"]');
        if(selected?.animate){selected.getAnimations().forEach(animation=>animation.cancel());selected.animate([{transform:'scale(.94)'},{transform:'scale(1.035)',offset:.6},{transform:'scale(1)'}],{duration:420,easing:'cubic-bezier(.2,.75,.25,1)'})}
      };
      section.addEventListener('change',event=>{if(event.target.matches('[data-srd-variant-select]'))pulse()});
      section.addEventListener('input',event=>{if(event.target.matches('[data-srd-order-quantity]')&&event.target.validity.valid)pulse()});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if(mobile.addEventListener)mobile.addEventListener('change',()=>{if(mobile.matches)init()});
  if(reduced.addEventListener)reduced.addEventListener('change',()=>{if(!reduced.matches)init()});
})();
